import { promisify } from "util"
import { lstat } from "fs"

const lstatPromisified = promisify(lstat)

export const fileLStat = async (file) => {
  const lstat = await lstatPromisified(file)
  return lstat
}
